import React, { useState, useEffect, useRef } from 'react';

// Ruteador
import { Link } from "react-router-dom";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp } from "@fortawesome/pro-solid-svg-icons";
import { faTriangleExclamation } from "@fortawesome/pro-duotone-svg-icons";

import { get } from 'aws-amplify/api';

import parse from 'html-react-parser';

// LoadPanel
import { LoadPanel } from 'devextreme-react/load-panel';

// Gallery
import Gallery from 'devextreme-react/gallery';
import { Popup } from 'devextreme-react/popup';

import '../Gallery.css';

export default function Home(props) {
  const [styles, setStyles] = useState({});
  const [popupVisible, setPopupVisible] = useState(false);
  const [homePayload, setHomePayload] = useState({ custrecord_al_kiosco_cfg_body_home: '<div></div>' });

  const [visibleLoadPanel, setVisibleLoadPanel] = useState(false);

  const [gallery, setGallery] = useState(false);

  const beginButton = React.useCallback(async () => {
    // history.push('/Clusters');
  }, []);

  const getStyles = React.useCallback(async () => {
    setVisibleLoadPanel(true);

    try {
      const apiName = 'kioscoAPI';
      const path = '/styles';

      const myInit = {
        headers: {
          'Content-Type': 'application/json'
        },
        queryStringParameters: {}
      };

      const response = await get({
        apiName,
        path,
        options: myInit
      }).response;

      var stylesGet = await response.body.json();

      setStyles(stylesGet);
    }
    catch (error) {
      console.error('Error fetching styles:', error);
    }
    finally {
      setVisibleLoadPanel(false);
    }
  }, []);

  const getKioscoHome = React.useCallback(async () => {
    setVisibleLoadPanel(true);

    try {
      const apiName = 'kioscoAPI';
      const path = '/home';

      const myInit = {
        headers: {
          'Content-Type': 'application/json'
        },
        queryStringParameters: {}
      };

      const response = await get({
        apiName,
        path,
        options: myInit
      }).response;

      var homeGet = await response.body.json()

      setHomePayload(homeGet);
    }
    catch (error) {
      console.error('Error fetching home:', error);
    }
    finally {
      setVisibleLoadPanel(false);
    }
  }, []);

  useEffect(() => {
    async function initialize() {
      await getStyles();
      await getKioscoHome();
    }

    initialize();

  }, [getKioscoHome, getStyles]);

  const optionsParseMantenimiento = {
    replace: (domNode) => {
      if (domNode.name === 'fontawesomeicon' && domNode.attribs?.icon === '{faTriangleExclamation}') {
        return <FontAwesomeIcon icon={faTriangleExclamation} size="3x" />;
      }
    },
  };

  return (
    <div>
      <div className='ml-3 mr-3 p-2 bg-white'>
        {homePayload.custrecord_al_kiosco_cfg_mantenimiento ?
          <Popup
            visible={true}
            dragEnabled={false}
            hideOnOutsideClick={false}
            showCloseButton={false}
            showTitle={false}
            width={500}
            height={185}
          >
            <div>
              {parse(homePayload.custrecord_al_kiosco_cfg_mens_mant, optionsParseMantenimiento)}
            </div>

          </Popup>
          :
          (<div></div>)
        }
        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          visible={visibleLoadPanel}
          showIndicator={true}
          message="Por favor espere..."
          shading={true}
          showPane={true}
          hideOnOutsideClick={false}
        />
        {
          homePayload.custrecord_al_kiosco_cfg_publicidad ? (
            <div className="flex justify-center">
              <Gallery
                id="gallery"
                dataSource={homePayload.publicidad}
                height={homePayload.custrecord_al_kiosco_cfg_pub_height}
                width={homePayload.custrecord_al_kiosco_cfg_pub_ancho}
                slideshowDelay={homePayload.custrecord_al_kiosco_cfg_pub_delay}
                loop={true}
                showNavButtons={true}
                showIndicator={true}
              />
            </div>
          ) : (
            <div></div>
          )
        }
        <p className="font-sans text-xl font-bold">{homePayload.custrecord_al_kiosco_cfg_saludo}</p><br />
        <div>{parse(homePayload.custrecord_al_kiosco_cfg_body_home)}</div>
      </div>

      {!homePayload.custrecord_al_kiosco_cfg_mantenimiento ?
        <Link to="/Invoice">
          <button className={styles.custrecord_al_kiosco_cfg_class_comenzar} onClick={() => beginButton()}>
            <FontAwesomeIcon icon={faThumbsUp} size='lg' />  Comenzar
          </button>
        </Link> :
        (<div></div>)
      }
    </div>
  );
};